import { Navigate, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

const NavigateToDocumentsPage = () => {
  const { navigation } = useNavigation()
  const params = useParams()
  const to = navigation.employees.id.documents.list.fullPath({ id: Number(params.id) })

  return <Navigate replace to={to} />
}

export default NavigateToDocumentsPage
